module.exports = __webpack_public_path__ + "img/android-home-04.ddb5c9f5.jpg";